import { supabaseClient } from "supabase/supabase";

export const queryCurrentUser = async () => {
  const { data } = await supabaseClient.auth.getUser();

  const user = await supabaseClient
    .from("users")
    .select("*")
    .eq("auth_uid", data.user?.id!)
    .single();

  return user.data;
};
